import { isly } from "isly";
import { Date } from "../Date";
import { system } from "../system";
import { Number as WeekNumber } from "./Number";
import { Parts as WeekParts } from "./Parts";
export var Week;
(function (Week) {
    var _a;
    Week.Number = WeekNumber;
    Week.Parts = WeekParts;
    _a = isly
        .string(value => {
        const match = /^(\d{4})-W(\d{2})$/.exec(value) ?? [];
        return (Date.Year.is(match[1]) &&
            (WeekNumber.Numeric.parse(match[2]) ?? 54) <= WeekParts.lastWeek(Date.Year.Numeric.parse(match[1])));
    }, "YYYY-Www")
        .rename("isoly.Week")
        .describe("ISO 8601 week number in the format YYYY-Www (ex: 2025-W04). Week starts on Monday and the week containing the first Wednesday of the year is week 1 of that year.")
        .bind(), Week.type = _a.type, Week.is = _a.is, Week.flawed = _a.flawed;
    function split(week) {
        return week.split("-W").map(system.Number);
    }
    Week.split = split;
    function parts(week) {
        const [y, w] = split(week);
        return { year: y, week: w };
    }
    Week.parts = parts;
    function from(date) {
        const result = Week.Parts.is(date) ? date : WeekParts.from(date);
        return `${result.year.toString().padStart(4, "0")}-W${result.week.toString().padStart(2, "0")}`;
    }
    Week.from = from;
    function now() {
        return from(Week.Parts.now());
    }
    Week.now = now;
    function next(week, weeks = 1) {
        return from(Week.Parts.next(parts(week), weeks));
    }
    Week.next = next;
    function previous(week, weeks = 1) {
        return next(week, -weeks);
    }
    Week.previous = previous;
    function first(week) {
        return Week.Parts.first(parts(week));
    }
    Week.first = first;
    function last(week) {
        return getDate(week, 7);
    }
    Week.last = last;
    function getYear(week) {
        return parts(week).year;
    }
    Week.getYear = getYear;
    function getWeek(week) {
        return parts(week).week;
    }
    Week.getWeek = getWeek;
    function getDate(week, day) {
        return Week.Parts.getDate(parts(week), day);
    }
    Week.getDate = getDate;
    function getDays(week) {
        return Week.Parts.getDays(parts(week));
    }
    Week.getDays = getDays;
})(Week || (Week = {}));
//# sourceMappingURL=index.js.map